import {
  TouchpointDTOContentType,
  TouchpointCreateRequestPopulationType,
  TouchpointCreateRequestType,
} from "generated/schemas";

export type FormContentType = TouchpointDTOContentType | "";

export type FormPopulationType = TouchpointCreateRequestPopulationType | "";

const POPULATION_TYPE_VALUES = new Set<string>(Object.values(TouchpointCreateRequestPopulationType));

export const toFormPopulationType = (value?: string): FormPopulationType => {
  if (value && POPULATION_TYPE_VALUES.has(value)) {
    return value as FormPopulationType;
  }
  return "";
};

export interface AddEmailFormData {
  emailTemplateId?: string;
  name: string;
  populationType: FormPopulationType;
  contentType: FormContentType;
  insightsActivator: boolean;
  applyClientTheme?: boolean;
  folderId?: string;
  fiscalYear: number;
  copyCode: string;
  classes?: string[];
}

export interface EditEmailFormData {
  name: string;
  populationType: FormPopulationType;
  contentType: FormContentType;
  insightsActivator: boolean;
  campaignId?: string;
  copyCode: string;
  folderId?: string;
  classes?: string[];
}

export interface AddTouchpointFormData {
  touchpointTemplateId?: string;
  name: string;
  populationType: FormPopulationType;
  contentType: FormContentType;
  insightsActivator: boolean;
  folderId?: string;
  fiscalYear: number;
  copyCode: string;
  type?: TouchpointCreateRequestType;
  classes?: string[];
}

export interface EditTouchpointFormData {
  name: string;
  populationType: FormPopulationType;
  contentType: FormContentType;
  campaignId?: string;
  copyCode: string;
  folderId?: string;
  insightsActivator: boolean;
  classes?: string[];
}
